var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',[_c('Breadcrumb',{attrs:{"title":"Inventario - Editar sección","link":"/inventory/sections"}}),_c('FormCreateSection',{attrs:{"action":"UPDATE","dangers":_vm.casDangers},on:{"on-btn-ok":_vm.onHandleBtnOK}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }